const RankingBody = ({ ranking, setHeroPlayer }) => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {ranking.map((player) => (
          <div
            key={player?.Id}
            className="relative flex items-center space-x-3 px-8 py-6 bg-sec-grey-4 text-blue hover:text-white transition-all hover:bg-blue m-[3px]"
          >
            <div className="flex-shrink-0">
              <img
                className="w-20 h-20 rounded-full object-cover object-top shadow-md"
                src={player.Image || '/assets/images/players/no-photo.svg'}
                alt=""
              />
            </div>
            <div className="">
              <button
                className="focus:outline-none text-left"
                onClick={() => {
                  setHeroPlayer(player)
                  window.scroll({
                    top: 185,
                    left: 0,
                    behavior: 'smooth'
                  })
                }}
              >
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-sm font-bold">{player.Name}</p>
                <p className="truncate text-sm">{player.Point}</p>
                <p className="text-4xl font-bold">{player.Ranking}</p>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default RankingBody
